"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:no-any
/**
 * This version converter doesn't actually do anything but is useful for testing or when we have
 * a matching platform and internal version number
 */
class IdentityVersionConverter {
    upgradeExecuteCall(verb, parameters) {
        return {
            verb: verb,
            parameters: parameters,
        };
    }
    downgradeExecuteReturn(executeResponse) {
        return executeResponse;
    }
    downgradeNotification(notification) {
        return notification;
    }
}
exports.IdentityVersionConverter = IdentityVersionConverter;
//# sourceMappingURL=IdentityVersionConverter.js.map